import React from 'react'
import ProjectStep from "../components/ProjectStep";
import {generatePath} from "react-router-dom";
import ProjectIndustries from "../components/ProjectIndustries";
import Form from "../../../components/form/Form";
import TeamBlueprint from "../components/TeamBlueprint";

export default class TeamIndustriesStep extends ProjectStep {
    static TranslationKey = 'industries_step';

    static path = '/industries';
    static slug = 'industries';

    static HandleUnauthorized = false;

    static Optional = false;

    static ValidationMethodName = 'validateTeamIndustries';

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            template: null,
            // isLoading: true
        }
    }


    async componentDidMount() {
        await super.componentDidMount();

        // let template = await Service.fetchTemplate(this.props.project.template.id);
        //
        // this.promisedState({isLoading: false, template})
    }

    /**
     * The continue & back buttons
     */
    static showFormButtons() {
        return false
    }

    getStepName() {
        return false
    }

    /**
     * The subtitle shown on the form
     */
    getStepSubtitle() {

        return ``;
    }

    static hasCompleted(project) {
        return project.validateTeamIndustries();
    }

    /**
     * The step needed before editing
     */
    static StepNeedsValidation(project) {
        return false
    };

    static getPath(project) {
        let projectId = TB.isObject(project) ? project.id : project;


        return generatePath(`${TB.routes().clientProjectSetup}${this.path}`, {
            projectId
        })
    }


    render() {
        // if (this.state.isLoading || !this.state.template) {
        //     return <LoadingBanner message={"Loading project type details"} />
        // }
        return (
            <div className="flex flex-col items-stretch gap-4">
                <TeamBlueprint components={{roles: true, skills: true}}>
                    <p className="px-4 py-3 flex flex-row items-center justify-center gap-2">
                        <i className="fas fa-check-circle text-success text-[15px]"/>
                        <span>
                            Skills definition is complete! Below you can select <span className="uppercase font-semibold">industry expertise</span> desired for the project team.
                        </span>
                    </p>
                </TeamBlueprint>
                <div className="wizard-form-step project-team-step">
                    <Form
                        ref={this.formRef}
                        showRequired
                        title={null}
                        subtitle={null}
                        submitButton={false}
                        onSubmit={null}
                        background="transparent"
                        model={this.props.project}
                        onChange={this.props.onChange}
                        fields={[]}
                        minimal
                        isDisabled={this.props.isDisabled}>
                        <div className="flex flex-col items-stretch gap-4">

                            <div className="flex flex-col items-stretch gap-6 bg-white">
                                <div className="flex items-stretch relative project-skills-step flex-col gap-6">
                                    <div className="flex flex-row justify-between items-center pb-5">
                                        <div>
                                            <p className="text-xl font-medium text-left text-black">
                                                Industry Experience
                                            </p>

                                            <p className="text-sm text-left text-black">
                                                You can select industry expertise below that is important for your project
                                            </p>
                                        </div>
                                        {!this.props.shouldBeRedirected() && (
                                            <p className="flex flex-col gap-1 justify-center text-center">
                                                <span className="text-xs text-center text-black">
                                                    Rather discuss on a call?
                                                </span>
                                                <span onClick={() => {
                                                    if (this.props.isDisabled) {
                                                        return
                                                    }
                                                    return this.props.goToNextStep()
                                                }} className="clickable text-base underline font-semibold text-center text-primary">
                                                    SKIP THIS STEP
                                                </span>
                                            </p>
                                        )}
                                    </div>


                                    <ProjectIndustries onChange={this.props.onChange}
                                                       isDisabled={this.props.isDisabled}/>
                                </div>
                            </div>

                            <div className="mt-5 flex flex-col items-stretch">
                                {this.props.children}
                            </div>
                        </div>
                    </Form>

                </div>
            </div>
        )
    }
}